import { PRODUCT_LINE_CODE } from '../../../../../shared/constants/product-lines-codes';
import { readymix } from './readymix';
import { aggregates } from './aggregates';
import { cementBulk } from './cement-bulk';
import { cementBag } from './cement-bag';
import { cementBagAndMultiproduct } from './cement-bag-multiproduct';

export const coConfig = {
  [PRODUCT_LINE_CODE.READY_MIX]: readymix,
  [PRODUCT_LINE_CODE.AGGREGATES]: aggregates,
  [PRODUCT_LINE_CODE.BULK_CEMENT]: cementBulk,
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
  [PRODUCT_LINE_CODE.BAG_CEMENT_AND_MULTI_PRODUCT]: cementBagAndMultiproduct,
};
